module.exports = __webpack_public_path__ + "img/zcgl.ec651c85.svg";